import React from 'react';
import { Link,useLocation } from 'react-router-dom';
import { Box, Button, Grid, Typography } from '@mui/material';
import Breadcrumb from '../../../component/Breadcrumb';
import PageTabing from '../../../component/PageTabing';
import SearchBox from '../../../component/SearchBox';
import MessageTable from './MessageTable';
import { fetchReceiveMessageSheetData } from '../../../api/mappingApi';
import Loader from '../../../component/Loader/Loader';
import CanTabing from '../../../component/CanTabing';

const ECUReceiveMessages = () => {
    const location                                      =   useLocation();
    const [page, setPage]                               =   React.useState(0);
    const [showLoader, setShowLoader]                   =   React.useState(false);
    const [searchValue, setSearchValue]                 =   React.useState('');
    const [rowsPerPage, setRowsPerPage]                 =   React.useState(100);
    const [messageMappingData, setMessageMappingData]   =   React.useState([]);
    const [itemForLocal, setItemForLocal]               =   React.useState(false);
    const [showParameters, setShowParameters]           =   React.useState(true);

    const handleChangeTextValue = (event) => {
        setSearchValue(event.target.value);
    }

    React.useEffect(() => {
        if(!showParameters){
            fetchData(page,rowsPerPage,searchValue);
        } else {
            setMessageMappingData([])
        }
    },[page,rowsPerPage,showParameters]);

    const fetchData = async (page,rowsPerPage,searchValue) => {
        setShowLoader(true);
        const data = await fetchReceiveMessageSheetData(page,rowsPerPage,searchValue);
        setShowLoader(false);
        setMessageMappingData(data);
    }

    const handleSearch = async () => {
        if(searchValue !== ''){
            if(page > 0){
                setPage(0); 
            } else {
                fetchData(page,rowsPerPage,searchValue);
            }
        }
    }

    const handleClearSearch = () => {
        setSearchValue('');
        fetchData(page,rowsPerPage,'');
    }


    const handleChangePage = (event, pageVal) => {
        setPage(pageVal);
    }

    const handleChangeRowsPerPage = (event) => {
        const value = event.target.value === 'ALL' ? -1 : parseInt(event.target.value,10)
        setRowsPerPage(value);
        setPage(0);
    }

    return (
        <>
            {showLoader && 
                <Loader />
            }
            <Breadcrumb  title="ECU Receive Messages">
                <Typography component={Link} to="/" variant="subtitle2" color="primary" className="link-breadcrumb">
                Dashboard
                </Typography>
                <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
                CAN
                </Typography>
            </Breadcrumb>
            <PageTabing value="can" />
            <Box component="section">
                <Grid className="contentBox">
                    <CanTabing value="receive-messages" />   
                    {(!location.pathname.includes('mapping') || itemForLocal) &&
                        <Grid className="modbusButtons" container direction="row" display={'flex'} justifyContent={'flex-end'}>
                            <Grid item>
                                <Button
                                    component={Link} 
                                    to={location.pathname.includes('mapping') ? '/mapping/can/receive-messages/new' : '/can/receive-messages/new'}
                                    variant="contained"
                                    size="small"
                                    color="primary"
                                    sx={{mr:3}}
                                >Add New 
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    onClick={() => showParameters ? setShowParameters(false) : setShowParameters(true) }
                                    variant="contained"
                                    size="small"
                                    color="primary"
                                    sx={{mr:3}}
                                >{showParameters ? 'Show I5 Parameters'  : 'Hide I5 Parameters' }
                                </Button>
                            </Grid>
                        </Grid>
                    }  
                    {!showParameters &&
                        <>
                            <Grid sx={{ mb: 3 }} container direction="row">
                                <Grid item xs={12} sm={12} md={6}>
                                    <SearchBox
                                        label="English Text"
                                        value={searchValue}
                                        handleChangeTextValue={handleChangeTextValue}
                                        handleSearch={handleSearch}
                                        handleClearSearch={handleClearSearch} />
                                </Grid>
                            </Grid>
                            <MessageTable
                                page={page}
                                rowsPerPage={rowsPerPage}
                                messageData={messageMappingData}
                                handleChangePage={handleChangePage}
                                handleChangeRowsPerPage={handleChangeRowsPerPage} 
                            />
                        </>
                    }
                </Grid>
            </Box>
        </>
    );
};

export default ECUReceiveMessages;
